import ReactDOM from 'react-dom/client';
import App from './App';
import { logConsoleWelcome } from './utils/consoleWelcome';

logConsoleWelcome();

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
